export default function formatDate(dateText: string) {
  try {
    const date = new Date(dateText)
    return Intl.DateTimeFormat('pt-BR', {}).format(date)
  } catch (_) {
    return ''
  }
}
